import React from "react";
import { useDataManColumn } from "../../hooks/useDataManColumn";

export const DataManCompactViewColumnTitle: React.FC = () => {
  const { column } = useDataManColumn();

  return (
    <span className="font-medium text-content text-sm">{column?.title}</span>
  );
};

export const DataManCompactViewHierarchyColumnTitle: React.FC = () => {
  const { column } = useDataManColumn();

  return (
    <span className="font-medium text-content text-sm">{column?.title}</span>
  );
};
